module.exports = __webpack_public_path__ + "static/media/reward_wallet_modal_asset_01.97063298.svg";